export const GRAPHQL_VARIABLES = {
  filter: {
    _id: '5fc44f8784ffd06759c1a1f7'
  }
};

export const QUERY = `
  mutation billsRemove ($filter: AutoFilledFilterRemoveOnebillsInput!, $sort: SortRemoveOnebillsInput) {
    billsRemove (filter: $filter, sort: $sort) {
        recordId
        record {
            companyId
            invoiceId
            vendorId
            status
            allowedPaymentTypes
            currency
            total
            paid
            amountDue
            amountPaid
            metadata
            _id
            updatedAt
            createdAt
        }
        error {
            message
        }
    }
  }
`;
